'use client';
import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { KanbanColumn } from './kanbanMockData';

interface KanbanHeaderProps {
  activeColumnIndex: number;
  onColumnChange: (i: number) => void;
  columns: KanbanColumn[];
  totalCards: number;
  onRefresh: () => void;
  refreshing: boolean;
}

export default function KanbanHeader({
  activeColumnIndex,
  onColumnChange,
  columns,
  totalCards,
  onRefresh,
  refreshing,
}: KanbanHeaderProps) {
  return (
    <div className="flex flex-col border-b border-border px-4 lg:px-8 pt-5 pb-0 flex-shrink-0" style={{ background: 'var(--muted)' }}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <Link href="/dashboard" className="p-1.5 rounded-lg hover:bg-secondary transition-colors" aria-label="Back to dashboard">
            <Icon name="ArrowLeftIcon" size={16} className="text-muted-foreground" />
          </Link>
          <div>
            <h1 className="text-lg font-semibold text-foreground">Mobile App Redesign</h1>
            <p className="text-xs text-muted-foreground">{totalCards} total cards · Sprint 4</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={onRefresh} disabled={refreshing} className="btn-ghost h-8 px-2.5" aria-label="Refresh board">
            <Icon name="ArrowPathIcon" size={15} className={refreshing ? 'animate-spin' : ''} />
          </button>
          <Link href="/settings" className="btn-ghost h-8 px-2.5">
            <Icon name="UserGroupIcon" size={15} />
            <span className="hidden sm:inline text-xs">Team</span>
          </Link>
        </div>
      </div>

      {/* Mobile column tab dots */}
      <div className="lg:hidden flex items-center gap-1 pb-3">
        {columns.map((col, i) => (
          <button
            key={`col-dot-${col.id}`}
            onClick={() => onColumnChange(i)}
            className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium transition-all duration-150"
            style={{
              background: activeColumnIndex === i ? col.color + '20' : 'transparent',
              color: activeColumnIndex === i ? col.color : 'var(--muted-foreground)',
            }}
          >
            <span
              className="w-2 h-2 rounded-full"
              style={{ backgroundColor: activeColumnIndex === i ? col.color : 'var(--secondary)' }}
            />
            {col.title}
          </button>
        ))}
      </div>
    </div>
  );
}